import { render, staticRenderFns } from "./IRCOverview.vue?vue&type=template&id=5cf5bb02&scoped=true"
import script from "./IRCOverview.vue?vue&type=script&lang=js"
export * from "./IRCOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cf5bb02",
  null
  
)

export default component.exports